import type { YammerState } from '../../state/types';
import type { ApiMiddleware, ApiRequestType, ManagedApiRequest } from '../types';

import authorizationMiddleware from './authorization';
import graphqlMiddleware from './graphqlMiddleware';
import rateLimitedRequestMiddleware from './rateLimitedRequestMiddleware';

const requestMiddlewares: Record<ApiRequestType, ApiMiddleware[]> = {
  Ecs: [],
  Graphql: [authorizationMiddleware, graphqlMiddleware, rateLimitedRequestMiddleware],
  LegacyYammer: [authorizationMiddleware],
  SharePoint: [authorizationMiddleware],
  Ocps: [authorizationMiddleware],
  Ocv: [],
  Substrate: [authorizationMiddleware],
  ThirdParty: [],
  O365Shell: [authorizationMiddleware],
};

const addedMiddlewares: ApiMiddleware[] = [];

// Appends middleware to end of middleware chain.
// This method should be used only during bootstrap to minimize interfering with Redux state.
// Use only if the middleware has a dependency outside of `yammer-data`.
type AddMiddleware = (middleware: ApiMiddleware) => void;
export const addMiddleware: AddMiddleware = (middleware) => {
  addedMiddlewares.push(middleware);
};

type ApplyMiddleware = (apiRequest: ManagedApiRequest, state: YammerState) => Promise<ManagedApiRequest>;
export const applyMiddleware: ApplyMiddleware = (apiRequest, state) => {
  const { requestType } = apiRequest;
  const middlewares = [...requestMiddlewares[requestType], ...addedMiddlewares];

  return middlewares.reduce(async (memo, middleware) => middleware(await memo, state), Promise.resolve(apiRequest));
};
